import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, Typography } from "@mui/material";

const detailStyle = {
  marginBottom: "0.8rem",
  fontSize: "14px",
  color: "#555", // Slightly softer black para sa eleganteng look
  fontFamily: "Bell MT",
  lineHeight: "1.8", // Mas maluwag na line height para sa luxury feel
  // fontStyle: "italic" // Madalas italic ang description sa auction houses
};

/** Right column, under Prev / LOT / Next: artist, title, signed / medium / size with Read More,
 * or the lot_details_html version; plus the phone / tablet "View Lot Details" link. */
export default function LotSummary({
  artist,
  artistHtml,
  cleanedHtml,
  formatText,
  hasAnyDetails,
  isDesktop,
  isExpanded,
  isWidraw,
  lotHtml,
  medium,
  setIsExpanded,
  setOpenDetailsModal,
  signedDated,
  size,
  title,
}) {
  return (
    <>
      {/* 3. ARTIST / TITLE DETAILS */}
      {isWidraw !== 1 && (
        <div style={{ marginTop: "25px", padding: "0 5px" }}>
          {lotHtml === null || lotHtml === "" ? (
            /* --- ORIGINAL UI (SHOWS IF lot_details_html IS EMPTY) --- */
            <>
              <h1
                style={{
                  fontSize: 20,
                  fontWeight: "400",
                  textTransform: "uppercase",
                  marginBottom: "10px",
                  color: "#000",
                  lineHeight: 1.1,
                  fontFamily: "'Playfair Display', serif",
                  letterSpacing: "0.5px",
                }}
                dangerouslySetInnerHTML={{ __html: artist }}
              ></h1>

              <h3
                style={{
                  fontSize: 18,
                  fontStyle: "italic",
                  fontWeight: "400",
                  color: "#444",
                  marginBottom: "25px",
                  fontFamily: "'Georgia', serif",
                  lineHeight: 1.4,
                }}
                dangerouslySetInnerHTML={{ __html: title }}
              ></h3>

              <div
                style={{
                  lineHeight: 1.8,
                  fontSize: "14px",
                  color: "#555",
                  letterSpacing: "0.2px",
                }}
              >
                {/* I-check muna kung may kahit isang field na may laman */}
                {(signedDated || medium || size) && (
                  <div style={{ marginTop: "30px" }}>
                    {/* CONTAINER PARA SA DETAILS */}
                    <div
                      style={{
                        maxHeight: isExpanded ? "3370px" : "100px", // Mas maiksi para sa teaser look
                        overflow: "hidden",
                        position: "relative",
                        transition:
                          "max-height 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
                      }}
                    >
                      {/* RENDER FIELDS ONLY IF THEY HAVE VALUES */}
                      {signedDated && (
                        <p
                          style={detailStyle}
                          dangerouslySetInnerHTML={{
                            __html: formatText(signedDated),
                          }}
                        />
                      )}

                      {medium && (
                        <p
                          style={detailStyle}
                          dangerouslySetInnerHTML={{
                            __html: formatText(medium),
                          }}
                        />
                      )}

                      {size && (
                        <p
                          style={detailStyle}
                          dangerouslySetInnerHTML={{
                            __html: formatText(size),
                          }}
                        />
                      )}

                      {/* Elegant Fade Out - lalabas lang kung mahaba ang text at hindi pa expanded */}
                      {!isExpanded && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            width: "100%",
                            height: "50px",
                            background:
                              "linear-gradient(transparent, #fff)",
                          }}
                        />
                      )}
                    </div>

                    {/* SOTHEBY'S STYLE TOGGLE */}
                    {/* Lalabas lang ang button kung may laman ang data */}
                    <div
                      style={{
                        marginTop: "10px",
                        borderTop: "1px solid #f0f0f0",
                        paddingTop: "15px",
                        display: "flex",
                      }}
                    >
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          letterSpacing: "1.5px",
                          textTransform: "uppercase",
                          cursor: "pointer",
                          color: "#1a1a1a",
                          display: "inline-flex",
                          alignItems: "center",
                          transition: "color 0.3s ease",
                        }}
                        className="read-more-btn"
                      >
                        {isExpanded ? "— Read Less" : "+ Read More"}
                      </span>
                    </div>
                  </div>
                )}

                {/* MOBILE MODAL TRIGGER (VIEW LOT DETAILS) */}
                {/* Dapat laging available ang modal trigger sa mobile kahit custom HTML ang gamit */}
                {!isDesktop && hasAnyDetails ? (
                  <Box sx={{ textAlign: "left", mt: 2, mb: 1 }}>
                    <Typography
                      onClick={() => setOpenDetailsModal(true)}
                      sx={{
                        fontSize: "12px",
                        fontWeight: 900,
                        letterSpacing: "1.5px",
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: "#2f2e2e",
                        textTransform: "uppercase",
                        borderBottom: "2px solid #000",
                        pb: 0.5,
                        "&:active": { opacity: 0.6 },
                      }}
                    >
                      View Lot Details
                      <ArrowForwardIosIcon
                        sx={{ fontSize: "10px", fontWeight: 900 }}
                      />
                    </Typography>
                  </Box>
                ) : null}
              </div>
            </>
          ) : (
            /* --- NEW UI (SHOWS IF lot_details_html HAS CONTENT) --- */
            <div style={{ marginBottom: "20px" }}>
              <div>
                {/* Artist - separate Typography with custom font */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: 20,
                    fontWeight: "400",
                    textTransform: "uppercase",
                    marginBottom: "10px",
                    color: "#000",
                    lineHeight: 1.1,
                    fontFamily: "'Playfair Display', serif",
                    letterSpacing: "0.5px",
                  }}
                >
                  {artistHtml}
                </Typography>

                {/* --- SOTHEBY'S STYLE READ MORE WRAPPER --- */}
                <div style={{ position: "relative" }}>
                  <div
                    className="custom-lot-details"
                    style={{
                      maxHeight: isExpanded ? "none" : "150px", // Limitadong taas
                      overflow: "hidden",
                      transition:
                        "max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                      position: "relative",
                      // Optional: Idagdag ito kung gusto mo ng Sotheby's font style sa loob
                      fontFamily: "'Georgia', serif",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#333",
                    }}
                    dangerouslySetInnerHTML={{ __html: cleanedHtml }}
                  />

                  {/* Elegant Fade: Lalabas lang kapag naka-collapse */}
                  {!isExpanded && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "60px",
                        background:
                          "linear-gradient(transparent, rgba(255,255,255,0.9), #fff)",
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </div>

                {/* MINIMALIST TOGGLE BUTTON */}
                <div
                  style={{
                    marginTop: "15px",
                    borderTop: "1px solid #eee",
                    paddingTop: "12px",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      letterSpacing: "1.2px",
                      textTransform: "uppercase",
                      cursor: "pointer",
                      color: "#000",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    {isExpanded ? "- Read Less" : "+ Read More"}
                  </span>
                </div>
              </div>

              {/* Dapat laging available ang modal trigger sa mobile kahit custom HTML ang gamit */}
              {!isDesktop && hasAnyDetails ? (
                <Box sx={{ textAlign: "left", mt: 2, mb: 1 }}>
                  <Typography
                    onClick={() => setOpenDetailsModal(true)}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 900,
                      letterSpacing: "1.5px",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      color: "#2f2e2e",
                      textTransform: "uppercase",
                      borderBottom: "2px solid #000",
                      pb: 0.5,
                      "&:active": { opacity: 0.6 },
                    }}
                  >
                    View Lot Details{" "}
                    <ArrowForwardIosIcon
                      sx={{ fontSize: "10px", fontWeight: 900 }}
                    />
                  </Typography>
                </Box>
              ) : null}
            </div>
          )}

          <hr
            style={{
              margin: "35px 0",
              borderTop: "1px solid #f2f2f2",
            }}
          />
        </div>
      )}
    </>
  );
}
